<div class="listWrapper">
  <itl-info-box *ngIf="nothingChecked">{{ 'integratedCare.edit.noArticlesWarning' | translate }}</itl-info-box>
  <itl-single-ordered-article-list-item
    *ngFor="let orderedArticleLine of order.orderedArticleLines; let last = last"
    [articleLine]="orderedArticleLine"
    [order]="order"
    [isLast]="last"
    [showDetails]="order.orderedArticleLines[changedItemIndex] === orderedArticleLine"
    (articleLineChange)="changed($event)"
    [stock]="this.stock$ | async"
    [isArticleEditDisabled]="isArticleEditDisabled"
  ></itl-single-ordered-article-list-item>
</div>
<ng-template #footerBar>
  <div class="button-container">
    <button class="footer-button" (click)="presentPopover()" *ngIf="!isArticleEditDisabled">•••</button>
    <itl-button class="stock-button" (click)="checkStock()" *ngIf="configStockEnabled">
      <ion-icon name="alberta-fab-stock-check"></ion-icon
      ><span class="stock-button-text">{{ 'fab-action.stock' | translate }}</span>
    </itl-button>
  </div>
</ng-template>
